import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import { useContextSelector } from 'use-context-selector';
import { moveNodeCommand } from '../../commands/node.js';
import { findNode } from '../../utils/node.js';
import { jsx } from '@emotion/react';
import '../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../contexts/internal/EditorContext.js';
import 'qs';
import 'query-string';

function Accordion(_ref) {
  var children = _ref.children,
    path = _ref.path,
    buttonPlacement = _ref.buttonPlacement,
    peekable = _ref.peekable,
    initialExpanded = _ref.initialExpanded;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  function expand() {
    setExpanded(true);
  }
  function collapse() {
    setExpanded(false);
  }
  useEffect(function () {
    setExpanded(initialExpanded || false);
  }, [initialExpanded]);
  useEditorInitializer({
    path: path,
    buttonPlacement: buttonPlacement
  });
  return jsx("div", null, React__default.Children.map(children, function (child) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return child;
    }
    return /*#__PURE__*/React__default.cloneElement(child, {
      expanded: expanded,
      expand: expand,
      collapse: collapse,
      peekable: peekable
    });
  }));
}
function useEditorInitializer(_ref2) {
  var path = _ref2.path,
    buttonPlacement = _ref2.buttonPlacement;
  var context = useContextSelector(EditorContext, function (context) {
    return context;
  });
  var node = context ? findNode(context.state.document, path) : undefined;
  useEffect(function () {
    if (!context || !node) {
      return;
    }
    if (buttonPlacement === 'top' && node.children[0].type === 'accordionContent') {
      // when button placement is top,
      // move accordion content to last
      context.dispatch(moveNodeCommand([].concat(_toConsumableArray(path), [0]), [].concat(_toConsumableArray(path), [node.children.length])));
    }
    if (buttonPlacement === 'bottom' && node.children[0].type === 'accordionButton') {
      // when button placement is bottom,
      // move accordion content to first
      context.dispatch(moveNodeCommand([].concat(_toConsumableArray(path), [node.children.length - 1]), [].concat(_toConsumableArray(path), [0])));
    }
    context.setState(function (state) {
      return _objectSpread2(_objectSpread2({}, state), {}, {
        cursor: path
      });
    });
  }, [buttonPlacement]);
}

export { Accordion };
//# sourceMappingURL=Accordion.js.map
